import { render, staticRenderFns } from "./MessagebarItem.vue?vue&type=template&id=0ef44138&scoped=true&"
import script from "./MessagebarItem.vue?vue&type=script&lang=js&"
export * from "./MessagebarItem.vue?vue&type=script&lang=js&"
import style0 from "./MessagebarItem.vue?vue&type=style&index=0&id=0ef44138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef44138",
  null
  
)

export default component.exports